import { combineEpics } from 'redux-observable';
import { fetchCalendarLink$ } from 'modules/calendar/epics/fetchCalendarLink$';

export default combineEpics(fetchCalendarLink$);
